import { FC, memo } from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const SkeletonBase = styled.div`
  background: linear-gradient(
    90deg,
    #f0f0f0 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 8px;
`;

const CardContainer = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1);
  border: 1px solid #e3e8ef;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const LogosContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const LogoSkeleton = styled(SkeletonBase)`
  width: 48px;
  height: 48px;
  border-radius: 12px;
`;

const ConnectorSkeleton = styled(SkeletonBase)`
  width: 24px;
  height: 2px;
`;

const BadgeSkeleton = styled(SkeletonBase)`
  width: 80px;
  height: 28px;
  border-radius: 20px;
`;

const StatsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
`;

const StatSkeleton = styled(SkeletonBase)`
  width: 100px;
  height: 16px;
`;

const ButtonSkeleton = styled(SkeletonBase)`
  width: 100%;
  height: 48px;
  border-radius: 12px;
`;

const ChannelCardSkeleton: FC = memo(() => {
  return (
    <CardContainer>
      <Header>
        <LogosContainer>
          <LogoSkeleton />
          <ConnectorSkeleton />
          <LogoSkeleton />
        </LogosContainer>
        <BadgeSkeleton />
      </Header>

      <StatsContainer>
        <StatSkeleton />
        <StatSkeleton />
      </StatsContainer>

      <ButtonSkeleton />
    </CardContainer>
  );
});

ChannelCardSkeleton.displayName = 'ChannelCardSkeleton';

export default ChannelCardSkeleton;
